import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import AliceStore from 'bundles/alice/stores/AliceStore';
import ItemFeedbackStore from 'bundles/content-feedback/stores/ItemFeedbackStore';
import ProgramSwitcherStore from 'bundles/enterprise-legacy-learner-home/stores/ProgramSwitcherStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ProfileStore from 'bundles/profile/stores/ProfileStore';
import component from 'bundles/program-home/routes';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
import VideoTranscriptStore from 'bundles/video-logged-out-page/stores/VideoTranscriptStore';

// copy over from VLP, we should cleanup if not used
import 'css!bundles/global-styles/global-element-styles';

const appEnv = new Fluxible({
  component,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(ProgramSwitcherStore);
appEnv.registerStore(ProfileStore);
appEnv.registerStore(VideoTranscriptStore); // copy over from VLP, we should cleanup if not used
appEnv.registerStore(AliceStore);
appEnv.registerStore(ItemFeedbackStore); // copy over from VLP, we should cleanup if not used

export default appEnv;
